/* eslint-disable */
// extend and init speedrfp widget
if (srfp) {
  const options = {
    button: 'none',
    display: 'window',
    rfp_type: 'meeting',
    uid: 'WQS17',
    key: 'fba127ff4a244386',
    populateUid: 'getRfpUids',
  };

  window.getRfpUids = function () {
    const rfpProperties = speedrfp || {};
    const propertySelect = document.querySelector('.js-booking-event-property');

    if (!propertySelect) {
      return '';
    }

    const selectedProperty = propertySelect.value;
    const selectedPropertyData = rfpProperties[selectedProperty];

    if (!selectedPropertyData) {
      return '';
    }

    // may be comma separated list of uids
    return selectedPropertyData.code || '';
  };

  window.speedRFPWidget = new srfp.widget(options);
}
